// @flow
import React from 'react'
import LogInForm from '../containers/LogInForm'
import styled from 'styled-components'

const Div = styled.div`
  display: grid;
  justify-self: center;
  align-items: center;
  justify-items: center;
  height: 100%;
`

const LoginView = () => (
  <Div>
    <LogInForm />
  </Div>
)
export default LoginView



// WEBPACK FOOTER //
// ./src/LogIn/components/LogInView.js